export interface Land {
  id              : number;
  bezeichnung     : string;
  erlaubteNutzung : number[];
}

export interface LandAdmin {
  id              : number;
  bezeichnungDe   : string;
  bezeichnungFr   : string;
  bezeichnungIt   : string;
  sortierung      : number;
  zulassungsLand  : boolean;
  importLand      : boolean;
  heimtierErlaubt : boolean;
  nutztierErlaubt : boolean;
}

export class LandAdminCmd {
  id              ?: number;
  bezeichnungDe    : string  | null = null;
  bezeichnungFr    : string  | null = null;
  bezeichnungIt    : string  | null = null;
  sortierung       : number  | null = null;
  zulassungsLand   : boolean | null = null;
  importLand       : boolean | null = null;
  heimtierErlaubt  : boolean | null = null;
  nutztierErlaubt  : boolean | null = null;

  public constructor(init?: Partial<LandAdminCmd>) {
    Object.assign(this, init);
  }
}
